import React from 'react'

export default function Calendar(props) {
  return (
    <svg
      width={props.width ? props.width : '14'}
      height={props.height ? props.height : '15'}
      viewBox='0 0 14 15'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path d='M9.66797 1.33203V3.9987' stroke='#1D79FB' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round' />
      <path d='M4.33203 1.33203V3.9987' stroke='#1D79FB' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round' />
      <path d='M1 6H13' stroke='#1D79FB' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round' />
      <path
        d='M11.6667 2.66406H2.33333C1.59667 2.66406 1 3.26073 1 3.9974V12.6641C1 13.4007 1.59667 13.9974 2.33333 13.9974H11.6667C12.4033 13.9974 13 13.4007 13 12.6641V3.9974C13 3.26073 12.4033 2.66406 11.6667 2.66406Z'
        stroke='#1D79FB'
        stroke-width='1.5'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path d='M3.66797 8.66406H10.3346' stroke='#1D79FB' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round' />
      <path d='M3.66797 11.332H10.3346' stroke='#1D79FB' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round' />
    </svg>
  )
}
